var Option = function Option() {
  return null;
};

export default Option;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/Option.js
// module id = 1538
// module chunks = 0